/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import * as Board from 'solis/react/board';

import Autosize from 'solis/react/element/autosize';

import BoardData from 'solis/react/board/data/board';
import StyledData from 'solis/react/board/data/styled';
import ZoneSelection from 'solis/react/board/selection/zone';

import AccountEmphasis from 'solis/react/board/emphasis/account';

import Args from 'solis/claude/action/args';


const SETTINGS = { ...Board.Interactive, selection: new ZoneSelection(Args.BoardZone) };


const StyledBoard = styled(Board.WithData)`

  display: block;
`;


export default () =>
{
  const route = use(Route);
  const galaxy = use(Galaxy);

  const board = galaxy.getBoard(route.getArg('id'));
  const account = galaxy.getCurrentAccount();

  const data = new StyledData({ data: new BoardData({ board }), emphasis: new AccountEmphasis(account) });

  return <Autosize component = {StyledBoard} data = {data} zoom = {3} settings = {SETTINGS} />;
};
